import React from "react";

import KudaLogo from "../../assets/images/png/partner-logo/Kuda-Bank.png";
import OkraLogo from "../../assets/images/png/partner-logo/Okra.png";
import AutocheckLogo from "../../assets/images/png/partner-logo/autocheck.png";
import BambooLogo from "../../assets/images/png/partner-logo/bamboo.png";
import BundleLogo from "../../assets/images/png/partner-logo/bundle.png";
import CowrywiseLogo from "../../assets/images/png/partner-logo/cowrywise.png";
import CredPalLogo from "../../assets/images/png/partner-logo/credpal.png";
import FlutterwaveLogo from "../../assets/images/png/partner-logo/flutterwave.png";
import MonoLogo from "../../assets/images/png/partner-logo/mono.jpeg";
import MooveLogo from "../../assets/images/png/partner-logo/moove.png";
import NombaLogo from "../../assets/images/png/partner-logo/nomba.jpeg";
import OpayLogo from "../../assets/images/png/partner-logo/opay.webp";
import PalmPayLogo from "../../assets/images/png/partner-logo/palmpay.jpeg";
import PaystackLogo from "../../assets/images/png/partner-logo/paystack.png";
import PiggyvestLogo from "../../assets/images/png/partner-logo/piggyvest.png";
import ProspaLogo from "../../assets/images/png/partner-logo/prospa.png";
import TeamAptLogo from "../../assets/images/png/partner-logo/teamapt.png";
import ThriveAgricLogo from "../../assets/images/png/partner-logo/thrive_agric.jpeg";

import HootsuiteLogo from "../../assets/images/png/partner-logo/Hootsuite.png";
import UberLogo from "../../assets/images/png/partner-logo/Uber.png";
import AmazonLogo from "../../assets/images/png/partner-logo/amazon.webp";
import BoltLogo from "../../assets/images/png/partner-logo/bolt.png";
import CapitalOneLogo from "../../assets/images/png/partner-logo/capitalOne.png";
import FacebookLogo from "../../assets/images/png/partner-logo/facebook.webp";
import GoogleLogo from "../../assets/images/png/partner-logo/google.jpg";
import KPMGLogo from "../../assets/images/png/partner-logo/kpmg.png";
import MacdonaldLogo from "../../assets/images/png/partner-logo/macdonald.png";
import MastercardLogo from "../../assets/images/png/partner-logo/mastercard.webp";
import PwCLogo from "../../assets/images/png/partner-logo/pwc.png";
import SamsungLogo from "../../assets/images/png/partner-logo/samsung.png";
import SAPLogo from "../../assets/images/png/partner-logo/sap.png";
import ShopifyLogo from "../../assets/images/png/partner-logo/shopify.png";
import SlackLogo from "../../assets/images/png/partner-logo/slack.png";
import SquareLogo from "../../assets/images/png/partner-logo/square.png";
import StripeLogo from "../../assets/images/png/partner-logo/stripe.png";
import TiktokLogo from "../../assets/images/png/partner-logo/tiktok.png";

import * as Animate from "react-reveal";
import useSelectedLocation from "../../helpers/useSelectedLocation";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

const ImageCard = ({ image }) => (
  <div className="relative w-full h-16 object-contain">
    <img
      src={image || BundleLogo}
      className="w-24 h-14 object-contain"
      alt=""
    />
  </div>
);

const AfricaCompanies = () => {
  return (
    <>
      <Animate.Fade bottom>
        <ImageCard image={BundleLogo} />
        <ImageCard image={MooveLogo} />
        <ImageCard image={FlutterwaveLogo} />
        <ImageCard image={PaystackLogo} />
        <ImageCard image={MonoLogo} />
        <ImageCard image={CowrywiseLogo} />
        <ImageCard image={BambooLogo} />
        <ImageCard image={NombaLogo} />
        <ImageCard image={TeamAptLogo} />
        <ImageCard image={ProspaLogo} />
        <ImageCard image={PiggyvestLogo} />
        <ImageCard image={ThriveAgricLogo} />
        <ImageCard image={CredPalLogo} />
        <ImageCard image={OkraLogo} />
        <ImageCard image={PalmPayLogo} />
        <ImageCard image={KudaLogo} />
        <ImageCard image={OpayLogo} />
        <ImageCard image={AutocheckLogo} />
      </Animate.Fade>
    </>
  );
};

const OtherCountries = () => {
  return (
    <Animate.Fade bottom>
      <ImageCard image={SlackLogo} />
      <ImageCard image={FacebookLogo} />
      <ImageCard image={CapitalOneLogo} />
      <ImageCard image={GoogleLogo} />
      <ImageCard image={AmazonLogo} />
      <ImageCard image={SamsungLogo} />
      <ImageCard image={ShopifyLogo} />
      <ImageCard image={SquareLogo} />
      <ImageCard image={UberLogo} />
      <ImageCard image={TiktokLogo} />
      <ImageCard image={MastercardLogo} />
      <ImageCard image={MacdonaldLogo} />
      <ImageCard image={PwCLogo} />
      <ImageCard image={SAPLogo} />
      <ImageCard image={HootsuiteLogo} />
      <ImageCard image={KPMGLogo} />
      <ImageCard image={StripeLogo} />
      <ImageCard image={BoltLogo} />
    </Animate.Fade>
  );
};

const PartnersLogoSlider = ({ children }) => {
  return (
    <div className="block md:hidden">
      <OwlCarousel
        className="owl-carousel owl-theme"
        items={3}
        loop={true}
        autoplay={true}
        autoplayTimeout={2000}
        nav={false}
        dots={false}
        margin={28}
        stageClass="pt-5"
        responsiveClass={true}
        responsive={{
          0: {
            items: 3,
            nav: false,
          },
          600: {
            items: 3,
            nav: false,
          },
          1000: {
            items: 5,
            nav: false,
            loop: false,
          },
        }}
      >
        {children}
      </OwlCarousel>
    </div>
  );
};

const PartnersLogoSection = ({ showNews = true }) => {
  const selectedLocation = useSelectedLocation();
  return (
    <section className="pt-16 lg:pt-20 pb-20">
      <div className="container mx-auto px-4">
        <div className="mb-6 lg:mb-8">
          <Animate.Fade bottom>
            <p className="text-default text-lg font-mono font-medium">
              Our Talents Work With Many of these Leading Tech Companies
            </p>
          </Animate.Fade>
        </div>

        {/* <PartnersLogoSlider /> */}

        {selectedLocation?.name === "Africa" || !selectedLocation ? (
          <>
            {/* Mobile Only */}
            <PartnersLogoSlider>
              <OtherCountries />
            </PartnersLogoSlider>
            <PartnersLogoSlider>
              <AfricaCompanies />
            </PartnersLogoSlider>

            {/* Desktop Only */}
            <div className="hidden md:grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-x-8 gap-y-6 mx-auto items-center justify-center partners-logo-wrapper">
              <OtherCountries />
              <AfricaCompanies />
            </div>
          </>
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-x-8 gap-y-6 mx-auto items-center justify-center partners-logo-wrapper">
            <OtherCountries />
          </div>
        )}

        {showNews && (
          <div className="flex flex-row items-center lg:items-baseline mt-8 lg:mt-10">
            <div className="font-medium text-xs pl-3 pr-2 py-2 text-white btn-new">
              NEW⚡
            </div>
            <p className="text-xs lg:text-sm text-primary pl-4 font-mono">
              HP Inc to support Utiva's mission to empower African women.{" "}
              <a
                href="https://www.csrwire.com/press_releases/739141-hp-utiva-and-girl-rising-set-move-more-girls-tech-kenya "
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold"
              >
                Read more
              </a>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnersLogoSection;
